{
  "greeting": {
    "morning": "Good Morning,",
    "afternoon": "Good Afternoon,",
    "evening": "Good Evening,"
  },
  "selectDate": "Select date"
}
